const PHOTO_CAPTURE_URL = '/virtual/smart-skin-scan/photo-capture';

export { PHOTO_CAPTURE_URL };
